export default "__VITE_ASSET__DvP2A_fZ__"